import { useState, useEffect } from 'react';
import { checkWorkflowPermissions } from '../commonComponents/WorkflowTable/workflowPermissionUtils';

/**
 * Checks whether the current user has edit permission for a single, currently
 * selected workflow. Used to gate actions (e.g. "Customize Layout") that are
 * only available to workflow owners/editors, independent of the active
 * Manage Workflows tab (All vs. My Workflows).
 */
export function useSelectedWorkflowEditPermission(
	workflowId: string | undefined,
	userName: string | undefined
) {
	const [canEdit, setCanEdit] = useState(false);
	const [isCheckingPermission, setIsCheckingPermission] = useState(false);

	useEffect(() => {
		let isCurrent = true;

		async function checkPermission() {
			if (!workflowId || !userName) {
				setCanEdit(false);
				return;
			}

			setIsCheckingPermission(true);
			try {
				const authorizedIds = await checkWorkflowPermissions([workflowId], userName, 'edit');

				if (isCurrent) {
					setCanEdit(authorizedIds.includes(workflowId));
				}
			} finally {
				if (isCurrent) {
					setIsCheckingPermission(false);
				}
			}
		}

		checkPermission();

		return () => {
			isCurrent = false;
		};
	}, [workflowId, userName]);

	return { canEdit, isCheckingPermission };
}
